module.exports = __webpack_public_path__ + "static/media/games-library.d39eb3fb.svg";